import { setI18NextLanguage } from '#i18n';
import { saveGlobalPrefs } from '#prefs/prefsSlice';
import { useDispatch } from '#redux';

/**
 * Elige el idioma: lo aplica al momento y lo guarda en este dispositivo (la
 * misma preferencia que lee «Ajustes → Idioma»). Un idioma vacío vuelve al
 * del sistema.
 */
export function useGuardarIdioma() {
  const dispatch = useDispatch();
  return async (idioma: string) => {
    setI18NextLanguage(idioma);
    await dispatch(saveGlobalPrefs({ prefs: { language: idioma } }));
  };
}
